export function latest<T>(arr: T[]): T {
  return arr[arr.length - 1];
}

export function previous<T>(arr: T[]): T | null {
  return arr.length >= 2 ? arr[arr.length - 2] : null;
}

export function pctChange(current: number, prevVal: number | null): number | null {
  if (prevVal === null || prevVal === 0) return null;
  return ((current - prevVal) / prevVal) * 100;
}

export function yearOf(quarterLabel: string): number {
  const parts = quarterLabel.split(' ');
  const y = Number(parts[1]);
  return Number.isFinite(y) ? y : new Date().getFullYear();
}
